export default __webpack_public_path__ + "static/media/ParkPlace_logo_pack-2.804af6a4.webp";